"use client";
import React, { useCallback, useState } from "react";
import { gaCommonEvent } from "@/src/utils/gtagEvents";
import { IVideoItemProps } from ".";
import stl from "./videoItem.module.scss";
import { FmIcon } from "@/ui-component";
import VideoPlay from "../VideoPlay";
import classnames from "classnames";
interface IProps extends IVideoItemProps {}
const VideoItemClient: React.FC<React.PropsWithChildren<IProps>> = (props) => {
    const { data } = props;
    const { show_type = 1 } = data; //1:竖版视频，2:横版视频
    const [visible, setVisible] = useState(false);
    const [end, setEnd] = useState(false);
    const [start_time, setStartTime] = useState(0);
    const onStart = useCallback(() => {
        setEnd(false);
        setStartTime(new Date().getTime());
        gaCommonEvent("KOL_video_click", {
            event_category: "kol",
            event_label: data.title,
            video_id: data.id,
            time: (new Date().getTime() - start_time) / 1000,
        });
    }, [data.id, data.title, start_time]);

    const onEnd = useCallback(() => {
        setEnd(true);
        gaCommonEvent("KOL_video_rate", {
            event_category: "kol",
            event_label: data.title,
            video_id: data.id,
        });
    }, [data.id, data.title]);
    const onShow = () => {
        setVisible(true);
    };

    const onClose = useCallback(() => {
        setVisible(false);
        if (!end) {
            gaCommonEvent("KOL_video_time", {
                event_category: "kol",
                event_label: data.title,
                video_id: data.id,
                time: (new Date().getTime() - start_time) / 1000,
            });
        }
    }, [data.id, data.title, end, start_time]);
    return (
        <>
            <div className={stl["video-item-wrapper"]} onClick={onShow}>
                {props.children}
            </div>
            {visible && (
                <div
                    className={stl["video-guide-model-cover"]}
                    onClick={onClose}
                >
                    {show_type == 1 ? (
                        <div className={stl["frame-container"]}>
                            <div
                                className={stl["model-close"]}
                                onClick={onClose}
                            >
                                <FmIcon
                                    icon="icon--search-clear"
                                    style={{
                                        color: "#fff",
                                        fontSize: "32px",
                                    }}
                                />
                            </div>
                            <VideoPlay
                                onStart={onStart}
                                onEnd={onEnd}
                                src={data.complete_video_url}
                                style={{
                                    width: "100vw",
                                    height: "87vh",
                                }}
                            />
                        </div>
                    ) : (
                        <div
                            className={classnames(
                                stl["frame-container"],
                                stl["frame-container-center"],
                            )}
                        >
                            <div
                                className={stl["model-close"]}
                                onClick={onClose}
                            >
                                <FmIcon
                                    icon="icon--search-clear"
                                    style={{
                                        color: "#fff",
                                        fontSize: "32px",
                                    }}
                                />
                            </div>
                            <VideoPlay
                                onStart={onStart}
                                onEnd={onEnd}
                                src={data.complete_video_url}
                                style={{
                                    width: "100vw",
                                    height: "30vh",
                                }}
                            />
                        </div>
                    )}
                </div>
            )}
        </>
    );
};

export default VideoItemClient;
